
const ViewUserProfiles = ({ data }) => {
  return (
    <div className='table-responsive bg-light p-3 mt-2'>
      <table className='table table-sm table-border edit-grid-view'>
        <thead className='border-0'>
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Address</th>
            <th>Phone</th>
            <th>Email</th>
          </tr>
        </thead>

        <tbody>
          {data &&
            data.data.map((userProfile) => (
              <tr key={userProfile._id}>
                <td>
                  <img
                    width='30'
                    height='30'
                    src={userProfile.image}
                    alt={userProfile.name}
                    className='img-fluid rounded-pill'
                  />
                </td>
                <td>{userProfile.name}</td>
                <td>{userProfile.address}</td>
                <td>{userProfile.phone}</td>
                <td>{userProfile.user && userProfile.user.email}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default ViewUserProfiles
